import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import DesktopBackgroundImage from '../../images/header/Desktop-Banner-Doc-Upload.jpg';
import MobileBackgroundImage from '../../images/header/Mobile-Banner-Doc-Upload.jpg';

import DesktopSchedulerBackgroundImage from '../../images/header/Desktop-Banner-Client-Scheduler.jpg';
import MobileSchedulerBackgroundImage from '../../images/header/Mobile-Banner-Client-Scheduler.jpg';

import DesktopAccountServicesBackgroundImage from '../../images/header/Desktop-Banner-Account-Services.jpg';
import MobileAccountServicesBackgroundImage from '../../images/header/Mobile-Banner-Account-Services.jpg';

import DesktopActivateATMCardBackgroundImage from '../../images/header/Desktop-Banner-Activate-ATM-Card.jpg';
import MobileActivateATMCardBackgroundImage from '../../images/header/Mobile-Banner-Activate-ATM-Card.jpg';

import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import home from '../../images/icons/home.png';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
const currentURL = window.location.href;

const useStyles = makeStyles((theme) => ({
  accountServices: {
    [theme.breakpoints.up('lg')]: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderBottom: '5px solid red',
      backgroundImage: `url(${DesktopAccountServicesBackgroundImage})`
    },
    [theme.breakpoints.up('md')]: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderBottom: '5px solid red',
      backgroundImage: `url(${DesktopAccountServicesBackgroundImage})`
    },
    [theme.breakpoints.only('sm')]: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderBottom: '5px solid red',
      backgroundImage: `url(${MobileAccountServicesBackgroundImage})`
    },
    [theme.breakpoints.down('xs')]: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderBottom: '5px solid red',
      backgroundImage: `url(${MobileAccountServicesBackgroundImage})`
    },
  },
  activateCard: {
    [theme.breakpoints.up('lg')]: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderBottom: '5px solid red',
      backgroundImage: `url(${DesktopActivateATMCardBackgroundImage})`
    },
    [theme.breakpoints.up('md')]: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderBottom: '5px solid red',
      backgroundImage: `url(${DesktopActivateATMCardBackgroundImage})`
    },
    [theme.breakpoints.only('sm')]: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderBottom: '5px solid red',
      backgroundImage: `url(${MobileActivateATMCardBackgroundImage})`
    },
    [theme.breakpoints.down('xs')]: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderBottom: '5px solid red',
      backgroundImage: `url(${MobileActivateATMCardBackgroundImage})`
    },
  },
  videocall: {
    [theme.breakpoints.up('lg')]: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderBottom: '5px solid red',
      backgroundImage: `url(${DesktopSchedulerBackgroundImage})`
    },
    [theme.breakpoints.up('md')]: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderBottom: '5px solid red',
      backgroundImage: `url(${DesktopSchedulerBackgroundImage})`
    },
    [theme.breakpoints.only('sm')]: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderBottom: '5px solid red',
      backgroundImage: `url(${MobileSchedulerBackgroundImage})`
    },
    [theme.breakpoints.down('xs')]: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderBottom: '5px solid red',
      backgroundImage: `url(${MobileSchedulerBackgroundImage})`
    },
  },
  documentUpload: {
    [theme.breakpoints.up('lg')]: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderBottom: '5px solid red',
      backgroundImage: `url(${DesktopBackgroundImage})`
    },
    [theme.breakpoints.up('md')]: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderBottom: '5px solid red',
      backgroundImage: `url(${DesktopBackgroundImage})`
    },
    [theme.breakpoints.only('sm')]: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderBottom: '5px solid red',
      backgroundImage: `url(${MobileBackgroundImage})`
    },
    [theme.breakpoints.down('xs')]: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderBottom: '5px solid red',
      backgroundImage: `url(${MobileBackgroundImage})`
    },
  },
  changePin: {
    [theme.breakpoints.up('lg')]: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderBottom: '5px solid red',
      backgroundImage: `url(${DesktopActivateATMCardBackgroundImage})`
    },
    [theme.breakpoints.up('md')]: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderBottom: '5px solid red',
      backgroundImage: `url(${DesktopActivateATMCardBackgroundImage})`
    },
    [theme.breakpoints.only('sm')]: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderBottom: '5px solid red',
      backgroundImage: `url(${MobileActivateATMCardBackgroundImage})`
    },
    [theme.breakpoints.down('xs')]: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderBottom: '5px solid red',
      backgroundImage: `url(${MobileActivateATMCardBackgroundImage})`
    },
  },
  bannerContent: {
    position: 'relative',
    padding: theme.spacing(3),
    marginTop: '7rem',
    marginLeft: '4rem',
    [theme.breakpoints.up('lg')]: {
      marginLeft: '7.5rem',
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(6),
      paddingRight: 0,
    },
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
      marginTop: '0rem',
      marginLeft: '0rem',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  breadcrumbs: {
    padding: theme.spacing(0, 0, 0, 13),
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    [theme.breakpoints.up('lg')]: {
      marginLeft: '4rem',
    },
  },
  hideThis: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
    position: 'relative',
    padding: theme.spacing(3),
    marginTop: '7rem',
  },
}));

const Header = ({ page }) => {
  const classes = useStyles();
  switch (page) {
    case 1:
      return (
        <div>
          <Paper square={true} className={classes.accountServices}>
            <Grid container>
              <Grid item md={12}>
                <div className={classes.bannerContent}>
                  <Typography component='h3' variant='h3' color='inherit'>
                  ATM PIN    
                  </Typography>
                 {/*  <Typography component='h6' variant='h6' color='inherit'>
                  Flexi Card is a Loan ATM Card
                  </Typography> */}
                </div>
                 <div className={classes.hideThis}>
                  <Typography component='h4' variant='h4' color='inherit'>
                  ATM PIN    
                  </Typography>
                </div> 
              </Grid>
            </Grid>
          </Paper>
          <Breadcrumbs
            className={classes.breadcrumbs}
            separator={<NavigateNextIcon fontSize='small' />}
            aria-label='breadcrumb'
          >
            <a href={process.env.REACT_APP_URL}>
              <img src={home} style={{ width: '25px' }} alt='home' />
            </a>
            <Typography color='textPrimary' style={{ fontWeight: '700' }} >
              <Link href={`${process.env.REACT_APP_URL}AccountServices/`} underline="none" color="inherit">ATM PIN</Link>
            </Typography>
            <Typography color='textPrimary' style={{ fontWeight: '700' }} >
              Nominate/Change Flexi Card PIN           
            </Typography>
          </Breadcrumbs>
        </div>
      );
      break;
    case 2:
    return (
      <div>
        <Paper square={true} className={classes.activateCard}>
          <Grid container>
            <Grid item md={12}>
              <div className={classes.bannerContent}>
                <Typography component='h3' variant='h3' color='inherit'>
                Nominate Flexi Card PIN    
                </Typography>
                {/* <Typography component='h4' variant='h4' color='inherit'>
                  Debit/Prepaid/Flexi
                </Typography> */}
              </div>
              <div className={classes.hideThis}>
                <Typography component='h4' variant='h4' color='inherit'>
                Nominate Flexi Card PIN     
                </Typography>
                {/* <Typography component='h6' variant='h6' color='inherit'>
                  Debit/Prepaid/Flexi
                </Typography> */}
              </div>
            </Grid>
          </Grid>
        </Paper>

        <Breadcrumbs
          className={classes.breadcrumbs}
          separator={<NavigateNextIcon fontSize='small' />}
          aria-label='breadcrumb'
        >
          <a href={process.env.REACT_APP_URL}>
            <img src={home} style={{ width: '25px' }} alt='home' />
          </a>
          <Typography color='textPrimary' style={{ fontWeight: '700' }}>
            ATM PIN                    
          </Typography>
           <Typography color='textPrimary' style={{ fontWeight: '700' }}>
           Nominate Flexi Card PIN 
          </Typography> 
        </Breadcrumbs>
      </div>
    );
    case 3:
    return (
      <div>
        <Paper square={true} className={classes.videocall}>
          <Grid container>
            <Grid item md={12}>
              <div className={classes.bannerContent}>
                <Typography component='h3' variant='h3' color='inherit'>
                  Online Account Opening
                </Typography>
                <Typography component='h4' variant='h4' color='inherit'>
                  Schedule a Video Call
                </Typography>
              </div>
              <div className={classes.hideThis}>
                <Typography component='h4' variant='h4' color='inherit'>
                  Online Account Opening
                </Typography>
                <Typography component='h6' variant='h6' color='inherit'>
                  Schedule a Video Call
                </Typography>
              </div>
            </Grid>
          </Grid>
        </Paper>

        <Breadcrumbs
          className={classes.breadcrumbs}
          separator={<NavigateNextIcon fontSize='small' />}
          aria-label='breadcrumb'
        >
          <a href={process.env.REACT_APP_URL}>
            <img src={home} style={{ width: '25px' }} alt='home' />
          </a>
          <Typography color='textPrimary' style={{ fontWeight: '700' }}>
            Online Account Opening              
          </Typography>
          <Typography color='textPrimary' style={{ fontWeight: '700' }}>
            Schedule a Video Call
          </Typography>
        </Breadcrumbs>
      </div>
    );
    case 4:
    return (
      <div>
        <Paper square={true} className={classes.documentUpload}>
          <Grid container>
            <Grid item md={12}>
              <div className={classes.bannerContent}>
                <Typography component='h3' variant='h3' color='inherit'>
                  Online Account Opening
                </Typography>
                <Typography component='h4' variant='h4' color='inherit'>
                  Document Upload
                </Typography>
              </div>
              <div className={classes.hideThis}>
                <Typography component='h4' variant='h4' color='inherit'>
                  Online Account Opening
                </Typography>
                <Typography component='h6' variant='h6' color='inherit'>
                  Document Upload
                </Typography>
              </div>
            </Grid>
          </Grid>
        </Paper>

        <Breadcrumbs
          className={classes.breadcrumbs}
          separator={<NavigateNextIcon fontSize='small' />}
          aria-label='breadcrumb'
        >
          <a href={process.env.REACT_APP_URL}>
            <img src={home} style={{ width: '25px' }} alt='home' />
          </a>
          <Typography color='textPrimary' style={{ fontWeight: '700' }}>
            Online Account Opening              
          </Typography>
          <Typography color='textPrimary' style={{ fontWeight: '700' }}>
            Document Upload
          </Typography>
        </Breadcrumbs>
      </div>
    );
    case 5:
    return (
      <div>
        <Paper square={true} className={classes.changePin}>
          <Grid container>
            <Grid item md={12}>
              <div className={classes.bannerContent}>
                <Typography component='h3' variant='h3' color='inherit'>
                Change Flexi Card PIN    
                </Typography>
              </div>
               <div className={classes.hideThis}>
                <Typography component='h4' variant='h4' color='inherit'>
                Change Flexi Card PIN
                </Typography>
              </div> 
            </Grid>
          </Grid>
        </Paper>

        <Breadcrumbs
          className={classes.breadcrumbs}
          separator={<NavigateNextIcon fontSize='small' />}
          aria-label='breadcrumb'
        >
          <a href={process.env.REACT_APP_URL}>
            <img src={home} style={{ width: '25px' }} alt='home' />
          </a>
          <Typography color='textPrimary' style={{ fontWeight: '700' }}>
            ATM PIN               
          </Typography>
          <Typography color='textPrimary' style={{ fontWeight: '700' }}>
            Change Flexi Card PIN
          </Typography>
        </Breadcrumbs>
      </div>
    );
    default:
      return <Grid/>
  }
};

Header.propTypes = {
  post: PropTypes.object,
};

export default Header;
